export function trackMatomoPageViews(pages) {
    window._paq = window._paq || [];

    const pageList = Array.isArray(pages) ? pages : [pages];

    pageList.forEach(({ url, title }) => {
        if (url) window._paq.push(['setCustomUrl', url]);
        if (title) window._paq.push(['setDocumentTitle', title]);

        window._paq.push(['trackPageView']);
    });
}